import { Dialog, DialogTitle, DialogContent, DialogActions, Grid, InputLabel, Select, MenuItem, TextField } from "@mui/material";
import MDButton from "components/MDButton";
import { useState } from "react";
import { post } from "utils/WebService";
import { useMaterialUIController } from "context";

export default function LoteAssociacaoModal({ open, handleClose, marcacaoId, marcacaoObj }) {
    const [controller] = useMaterialUIController();
    const { darkMode } = controller;

    const [tipoAssoc, setTipoAssoc] = useState(marcacaoObj?.cvAlvo === 2 ? "contratos" : "devedores");
    const [idsList, setIdsList] = useState("");
    const [loading, setLoading] = useState(false);

    const handleApply = () => {
        if (!idsList.trim()) {
            alert("Informe os IDs");
            return;
        }
        
        const ids = idsList.split(/[\s,;]+/).map(i => parseInt(i.trim())).filter(i => !isNaN(i));
        
        if (ids.length === 0) {
            alert("Nenhum ID válido encontrado");
            return;
        }

        setLoading(true);
        const endpoint = tipoAssoc === "devedores" ? "/marcacoes/lote/devedores" : "/marcacoes/lote/contratos";
        
        const payload = {
            idMarcacao: marcacaoId,
        };
        
        if (tipoAssoc === "devedores") {
            payload.devedoresIds = ids;
        } else {
            payload.contratosIds = ids;
        }

        post(endpoint, payload).then(() => {
            setLoading(false);
            alert("Associação em lote realizada com sucesso!");
            handleClose();
        }).catch(() => {
            setLoading(false);
            alert("Erro ao realizar associação em lote");
        });
    };

    return (
        <Dialog 
            open={open} 
            onClose={handleClose} 
            maxWidth="sm" 
            fullWidth
            PaperProps={{
                sx: {
                    backgroundColor: darkMode ? "#4B4F5C" : "#ffffff",
                    color: darkMode ? "#ffffff" : "inherit"
                }
            }}
        >
            <DialogTitle sx={{ color: darkMode ? "#ffffff" : "inherit" }}>
                Associação em Lote - {marcacaoObj?.ccNome}
            </DialogTitle>
            <DialogContent dividers sx={{ borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : undefined }}>
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <InputLabel sx={{ color: darkMode ? "#ffffff" : "inherit", mb: 0.5 }}>Associar a</InputLabel>
                        <Select
                            fullWidth
                            value={tipoAssoc}
                            onChange={(e) => setTipoAssoc(e.target.value)}
                            sx={{ 
                                height: 44,
                                color: darkMode ? "#ffffff !important" : "inherit",
                                "& .MuiSelect-icon": { color: darkMode ? "#ffffff !important" : "inherit" },
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: darkMode ? "rgba(255, 255, 255, 0.3)" : undefined
                                }
                            }}
                            MenuProps={{
                                PaperProps: {
                                    sx: {
                                        backgroundColor: darkMode ? "#424550" : "#ffffff",
                                        color: darkMode ? "#ffffff" : "inherit"
                                    }
                                }
                            }}
                        >
                            {(marcacaoObj?.cvAlvo === 1 || marcacaoObj?.cvAlvo === 3) && <MenuItem value="devedores">Fichas (Devedores)</MenuItem>}
                            {(marcacaoObj?.cvAlvo === 2 || marcacaoObj?.cvAlvo === 3) && <MenuItem value="contratos">Contratos</MenuItem>}
                        </Select>
                    </Grid>
                    <Grid item xs={12}>
                        <InputLabel sx={{ color: darkMode ? "#ffffff" : "inherit", mb: 0.5 }}>IDs (separados por vírgula ou espaço)</InputLabel>
                        <TextField
                            multiline
                            rows={5}
                            fullWidth
                            variant="outlined"
                            placeholder="Ex: 102, 105, 203"
                            value={idsList}
                            onChange={(e) => setIdsList(e.target.value)}
                            sx={{
                                "& .MuiInputBase-input": {
                                    color: darkMode ? "#ffffff !important" : "inherit"
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: darkMode ? "rgba(255, 255, 255, 0.3)" : undefined
                                }
                            }}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ p: 2, borderColor: darkMode ? "rgba(255, 255, 255, 0.12)" : undefined }}>
                <MDButton 
                    variant="outlined"
                    color="secondary" 
                    onClick={handleClose}
                    sx={{
                        color: darkMode ? "#ffffff !important" : undefined,
                        borderColor: darkMode ? "rgba(255, 255, 255, 0.4) !important" : undefined
                    }}
                >
                    Cancelar
                </MDButton>
                <MDButton 
                    variant="contained"
                    color="info" 
                    onClick={handleApply} 
                    disabled={loading}
                    sx={{
                        backgroundColor: darkMode ? "#007bff !important" : undefined,
                        color: "#ffffff !important",
                        fontWeight: "bold"
                    }}
                >
                    Aplicar Lote
                </MDButton>
            </DialogActions>
        </Dialog>
    );
}
